export default "__VITE_ASSET__xwOtEtcu__"